export default str => (str ? str.replace(/\/$/, '') : '');
